<template>
  <div class="flex-page">
    <a-spin tip="授权中..." size="large">
      <div class="spin-content">
      </div>
    </a-spin>
  </div>
</template>

<script>
export default {
  name: 'Authorization',
  data() {
    return {
      merchantId: this.$route.query.merchantId ? this.$route.query.merchantId : 0,
      type: this.$route.query.type ? this.$route.query.type : 0,//1是公众号 2是小程序
      platformId: this.$route.query.platformId ? this.$route.query.platformId : 0,
      merchantName: this.$route.query.merchantName ? this.$route.query.merchantName : '',
      auth_code: this.$route.query.auth_code ? this.$route.query.auth_code : null
    }
  },
  mounted() {
    this.$nextTick(() => {
      document.querySelector('.container').setAttribute('style', 'background:none')
      if (this.auth_code) {
        this.authorization()
      } else {
        if (this.platformId && this.merchantId) {
          this.getWechatAppId()
        }
      }
    })
  },
  methods: {
    // 获取APPid
    getWechatAppId() {
      this.getHttpServices().getUserService().get('api/v2/wx/auth/getConfig').then(res => {
        this.getLogUtils().logWithTag('==getWechatAppId==', res)
        this.appId = res.componentAppId
        this.preAuthCode = res.preAuthCode
        if (this.appId) {
          this.goWeixinAuthor()
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 去授权页面
    goWeixinAuthor() {
      let url = location.origin + '/users/authorization?merchantId=' + this.merchantId + '&type=' + this.type + '&platformId=' + this.platformId + '&merchantName=' + this.merchantName
      let authorUrl = 'https://mp.weixin.qq.com/cgi-bin/componentloginpage?component_appid=' + this.appId + '&pre_auth_code=' + this.preAuthCode + '&redirect_uri=' + encodeURIComponent(url) + '&auth_type=' + this.type
      // window.open(authorUrl)
      location.href = authorUrl
    },
    authorization() {
      this.getHttpServices().getUserService().post('api/v2/wx/auth/user/authorization', {
        authorizationCode: this.auth_code,
        type: this.type,
        merchantId: this.merchantId,
        platformId: this.platformId,
        merchantName: this.merchantName
      }).then(res => {
        this.getLogUtils().logWithTag('==authorization==', res)
        this.goNewPage()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 去授权成功页面
    goNewPage() {
      let path = this.type == 1 ? '/platform/manager/officials' : '/platform/manager/applets'
      let domainName = ''
      if (this.platformId == 1) {//魔方平台
        domainName = location.origin
      } else if (this.platformId == 2) {//蜗友平台
        domainName = 'https://admin.woyoubooking.com'
      } else if (this.platformId == 3) {//熊猫平台
        domainName = 'https://gd.98panda.com'
      } else if (this.platformId == 5) {//东青平台
        domainName = 'https://b.yeyotravel.com'
      } else if (this.platformId == 6) {//飓风平台
        domainName = 'https://cus.buercp.com'
      } else if (this.platformId == 7) {//优行平台
        domainName = 'https://admin.youxingnet.com'
      } else if (this.platformId == 8) {//鲲鹏云平台
        domainName = 'https://b.cinaroc.com'
      } else if (this.platformId == 9) {//黄姚平台
        domainName = 'https://b.huangyao.cn'
      } else if (this.platformId == 10) {//阳春平台
        domainName = 'https://b.izhyc.cn'
      } else if (this.platformId == 11) {//乐清旅开
        domainName = 'https://b.yqltjt.net'
      } else if (this.platformId == 102) {//魔方窝友UAT环境
        domainName = 'https://admin2.pre.woyoubooking.com'
      } else if (this.platformId == 103) {//黄姚的测试环境
        domainName = 'https://test.huangyao.admin2.mofangx.com'
      } else if (this.platformId == 1101) {//卓樱桃
        domainName = 'https://b.zhuoyingtao.com'
      } else if (this.platformId == 12) {//广东省电信公司
        domainName = 'http://36.139.10.92:8091'
      }

      if (domainName) {
        location.href = domainName + path
      }
    }
  }
}
</script>
<style scoped>
.spin-content {
  width: 100%;
  height: 500px;
}
</style>
